import { useContext } from "react";
import { FiFileText, FiPackage } from "react-icons/fi";
import { Link } from "react-router-dom";

import { PageTitle } from "../../components/PageTitle";
import { AuthContext } from "../../contexts/AuthContext";
import { CanAccess } from "../../components/CanAccess";
import { TechVisitReportList } from "./TechVisitReportList/TechVisitReportList";

export function TechVisitReport() {
  const { user } = useContext(AuthContext);

  return (
    <div className="container mx-auto">
      <PageTitle
        title="Relatórios de Visita Técnica"
        backButton
        backPath="/home"
      />
      <div className="flex items-start justify-between mb-6 gap-4">
        <div className="flex gap-4">
          <CanAccess permission={["tech-visit-reports:create-visit", "tech-visit-reports:create"]} allowAdmin>
            <Link
              to="/tech-visit-reports/new"
              className="group bg-[#0085BD] text-white px-6 py-3 rounded-lg flex items-center gap-2 shadow-lg hover:bg-[#006a96] transition-all duration-200 hover:shadow-xl"
            >
              <FiFileText size={20} className="transition-transform duration-200 group-hover:rotate-12" />
              <span className="font-semibold">Nova Visita Técnica</span>
            </Link>
          </CanAccess>
          <CanAccess permission={["tech-visit-reports:create-delivery", "tech-visit-reports:create"]} allowAdmin>
            <Link
              to="/delivery-reports/new"
              className="group bg-green-600 text-white px-6 py-3 rounded-lg flex items-center gap-2 shadow-lg hover:bg-green-700 transition-all duration-200 hover:shadow-xl"
            >
              <FiPackage size={20} className="transition-transform duration-200 group-hover:rotate-12" />
              <span className="font-semibold">Nova Entrega</span>
            </Link>
          </CanAccess>
        </div>
      </div>
      <TechVisitReportList />
    </div>
  );
}
